// extracted by mini-css-extract-plugin
module.exports = {"Map":"FooterMap_Map__2jB56","MapContainer":"FooterMap_MapContainer__3NjTQ"};